<template>
    <v-list nav dense>
        <v-subheader class="pl-0">
            <v-hover v-slot:default="{ hover }">
                <v-btn small text color="grey darken-1" class="text-caption" @click.stop="$emit('update:expanded', !expanded)">
                    SNAPSHOT
                    <v-icon v-if="hover" right small>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
            </v-hover>
        </v-subheader>
        <v-expand-transition>
            <div v-show="expanded">
                <SnapshotMenu :collapsed="collapsed" :show-quick-actions="true" />
            </div>
        </v-expand-transition>
    </v-list>
</template>

<script>
const SnapshotMenu = () => import('@/components/SnapshotMenu.vue')

export default {
    name: 'DrawerSnapshotSection',
    components: {
        SnapshotMenu
    },
    props: {
        collapsed: {
            type: Boolean,
            default: false
        },
        expanded: {
            type: Boolean,
            default: true
        }
    }
}
</script>
